module.exports = __webpack_public_path__ + "img/sk.9142d792.png";